import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Banners from 'modules/expenses/components/expenses/PageContents/_Banners'
import Header from 'modules/expenses/components/expenses/PageContents/_Header'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

import { QuickFiltersProvider } from './QuickFiltersContext'

const Content = ({ children }: React.PropsWithChildren) => {
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useExpenses()

  return (
    <QuickFiltersProvider>
      <Box flexDirection="column" height="full" flexGrow paddingTop="s16" style={{ minHeight: '0' }}>
        <Banners />
        {!dataCollectionEnabled && (
          <Header title={i18n.t('expenses_v2.tabs.expenses')} filterType={'pending'} />
        )}
        <Box flexGrow style={{ minHeight: '0' }}>
          {children}
        </Box>
      </Box>
    </QuickFiltersProvider>
  )
}

export default Content
